module.exports = __webpack_public_path__ + "img/youtube.14e52c8e.svg";